module.exports = __webpack_public_path__ + "static/media/35.98d6d7cf.png";